document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll(".vehicle-selector-wrapper").forEach((wrapper, index) => {
		const button = wrapper.querySelector(".show-model-request-form");
		const dialog = wrapper.querySelector(".model-request-modal");
		const closeBtn = dialog?.querySelector(".model-request-modal__close");
		const formContainer = wrapper.querySelector(".model-request-modal__form-container");

		function getVehicleValues() {
			const year = wrapper.querySelector('select[name="filter.p.m.category.year"]')?.value || "";
			const make = wrapper.querySelector('select[name="filter.p.m.category.make"]')?.value || "";
			const model = wrapper.querySelector('select[name="filter.p.m.category.model"]')?.value || "";
			return { year, make, model };
		}

		const waitUntilReady = setInterval(() => {
			const selects = wrapper.querySelectorAll(".vehicle-selector-form select");
			if (selects.length > 0 && button) {
				selects.forEach((select) => {
					select.addEventListener("change", () => {
						const { year, make } = getVehicleValues();
						if (year && make) {
							button.style.display = "block";
						}
					});
				});

				// Show button immediately if values already set from cache
				const { year, make } = getVehicleValues();
				if (year && make) {
					button.style.display = "block";
				}

				clearInterval(waitUntilReady);
			}
		}, 200);

		const formID = window.shopDomain.includes('tuxmat.ca') ? 'a2063fd7' : 'fadc1357';

		if (button && dialog && closeBtn) {
			button.addEventListener("click", () => {
				const { year, make, model } = getVehicleValues();
				const modelRequestForm = formcrafts.createInlineForm({
					form: formID,
					target: document.getElementById(formContainer.id),
					seamless: true,
					redirectWithin: true,
					lang: window.shopLocale,
					values: {
						field4: year.trim(),
						field12: make.trim(),
						field13: model.trim()
					}
				});

				dialog.showModal();
			});
			closeBtn.addEventListener("click", () => dialog.close());
		}
	});
});
